import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[appColumnWidth]',
  standalone: true,
})
export class ColumnWidthDirective {
  @Input()
  @HostBinding('style.width')
  @HostBinding('style.min-width')
  public columnWidth!: string;
}
